import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Configuration from "../../Configuration";

/**
 * Class representing a button.
 */
class Button extends React.Component
{
    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    };

    static defaultProps = {
        disabled: false
    };

    render() {
        const {className, disabled, children, onClick} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        const disabledAp = disabled ?"disabled-ap":"";
        const classes = classNames("cccu-button digital-one"+client,disabledAp, {[className]: className !== undefined});

        return (
            <button className={classes} onClick={onClick} disabled={disabled}>
                {children}
            </button>
        )      
    }
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/widgets/Button.js